import React, {createRef, useRef} from "react";
import {connect,useSelector} from "react-redux";
import {Dimensions, Image, StyleSheet, Text, TouchableOpacity, View} from "react-native";
import Logo, {BOLogo} from "../Picto/Logo";
import AvatarIcon from "../Header/AvatarIcon";
import {compose} from "redux";
import {withTranslation} from "react-i18next";


// https://conversejs.org/docs/html/api/converse.html
// https://conversejs.org/docs/html/api/-_converse.html


let _converse = false;



// MessengerScreen component will update the listener when mounted
let listener = () => {};

export const importConverseJS = (user) => {
  console.log("IMPORT CONVERSE JS");

  if (_converse) { return; }

  _converse = true;

  const {web_public_url} = window.getGlobalVars();
  initializeConverseJS(user,{ web_public_url });
}


function initializeConverseJS(user,{ web_public_url }) {
  // use the same protocol as the page hosting the script
  let websocket_url = window.location.protocol === "http:" ? "ws://" : "wss://";
  const hostname = window.location.hostname;
  const port = window.location.port;

  const use_reverse_proxy = ["reticular.fr", "altelis.com"];

  if (use_reverse_proxy.some(x => hostname.endsWith(x))) {
    websocket_url = [
      websocket_url, hostname, (port ? `:${port}` : ""), "/im/ws"
    ].join('')
  } else {
    websocket_url = websocket_url + `${hostname}:5443/ws`;
  }

  // https://m.conversejs.org/docs/html/api/-_converse.html#event:initialized
  // window.addEventListener("converse-loaded", function(event) {})
  // const { converse } = event.detail;
  window.converse.initialize({
      "authentication": "login",
      "allow_logout": false,
      "credentials_url": "/im_api/v1/get_credentials",
      "discover_connection_methods": false,
      "allow_bookmarks":false,
      "websocket_url":  websocket_url,
      "auto_login": true,
      "auto_away":  300,
      "i18n": "fr",
      "auto_reconnect": true,
      "message_archiving": "always",
      "view_mode": "mobile",
      "allow_non_roster_messaging": true,
      "locked_muc_nickname" : true,
      "muc_nickname_from_jid" : true,
      "nickname":user.firstname + " "+user.lastname,
      "allow_contact_removal": false,
      "assets_path": "/bo/vendor/conversejs/",
      "muc_domain":"conference.localhost",
      "locked_muc_domain":true,
      "clear_cache_on_logout":true,
      "roomconfig_whitelist":[],
      "notify_all_room_messages": true,
      "whitelisted_plugins": ["converse-altelis"],
      "muc_show_info_messages": [],
      "trusted": true,
      "muc_roomid_policy_hint":"Min. 3, Max. 40 caractères, en minuscules, sans espaces, caractères spéciaux autorisés : . _ -",
      //"loglevel": "debug"
  });
}

class MessengerScreen extends React.Component{

    constructor(props) {
        super(props);
        this.html = "";
        this._navigateToPost = this._navigateToPost.bind(this);
    }

    _navigateToPost(event){
        const element = (event.target);
        if(element.tagName.toLowerCase() === 'reticular-link' ){
            const url  = element.getAttribute('data-href');
            const urlSplit = url.split("/");
            const id  = urlSplit[urlSplit.length - 1];

            this.props.navigation.navigate(
              "HomeStack",
              { screen: "PostFeed", params: { postId : id, focus_comment: false}}
            );
        }
    }



    componentDidMount() {
        this._setHeaderLogoCompteMessage();

        if(this.props.isDark){
            document.querySelector("body").classList.remove("light");
            document.querySelector("body").classList.add("dark");
        }else{
            document.querySelector("body").classList.remove("dark");
            document.querySelector("body").classList.add("light");
        }

        function insert() {

            if(document.querySelector('body > #conversejs')){
                document.body.setAttribute('id','conversejsContainer');
                window._converse.reticular.forceRosterRefresh();
                window._converse.reticular.openLastChat();
                window._converse.api.settings.set('muc_roomid_policy',/^[a-z0-9._-]{5,40}$/);
            }
        }

        // already loaded
        if (window.converse && window.converse.insertInto) {
          insert();
        } else {
          listener = insert
        }
        document.addEventListener('click',this._navigateToPost)
    }

    componentWillUnmount() {
        document.body.setAttribute('id','');
        window._converse.reticular.closeChat();
        document.removeEventListener('click',this._navigateToPost);
    }

    remove(){

    }

    _setHeaderLogoCompteMessage(){
        const styleHeaderGlobal = {
            shadowOpacity: 0,
            shadowRadius: 0,
            borderWidth:0,
            elevation: 0,
            borderColor:"transparent" ,
            borderBottomWidth:0,
            backgroundColor : this.props.theme.colors.primary.White.value,
            height:80
        }  ;

        this.props.navigation.setOptions({
            headerShown:true,
            headerRight : ()=>{},

            headerStyle: styleHeaderGlobal,
            headerTitleAlign: "center",
            title: "Messages",
            cardStyle: { backgroundColor: this.props.theme.colors.tertiary.grey3.value},
            headerLeft : ()=>
                <TouchableOpacity
                    onPress={()=>{this.props.navigation.navigate('MyProfil',{})} }>
                    <AvatarIcon style={{width:35,height:35,borderWidth:0,borderRadius:14}}  isHeader={true} icon={this.props.auth.compte.img}/>
                </TouchableOpacity>
            , });
    }

    getDimensions() {
        return Dimensions.get('window');
    }

    render() {
        const { width,height } = this.getDimensions();
        const styles = StyleSheet.create({
            conversejsContainer:{
                height:"80%"
            }
        })

        return  <View style={styles.conversejsContainer}  nativeID={'conversejsContainer'}></View>
    }
}
const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme, auth : state.AuthReducer};
}

export default compose(connect(mapStateToProps),withTranslation())(MessengerScreen);


